import { defineMessages } from 'react-intl';

const messages = defineMessages({
  downloadingData: {
    id: 'export-users.downloading-data',
    defaultMessage: 'Downloading...',
  },
  downloadReady: {
    id: 'export-users.download-ready',
    defaultMessage: 'Download ready',
  },
  cancelButton: {
    id: 'export-users.cancel-button',
    defaultMessage: 'Cancel',
  },
  generateButton: {
    id: 'export-users.generate-list-button',
    defaultMessage: 'Generate List',
  },
  downloadButton: {
    id: 'export-users.download-button',
    defaultMessage: 'Download',
  },
});

export default messages;
